module.exports = __webpack_public_path__ + "static/constellation_background-1f6ccc37bfac74232d4c136f2f1ea216.png";